export function useHandlePurchase() {
  return {
    handlePurchase: () => {
      console.error('Not implemented');
    },
    isStoreLoading: true,
  };
}
